<template>
  <div>
    <!-- Start Header Area -->
    <Header default-color="#c6c9d8">
      <img
          slot="logo"
          src="../../assets/images/layout/smile-logo-white.svg"
          class="logo-light"
          width="200"
          alt="Smile Magazine Logo"
      />
      <img
          slot="logo-dark"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-dark"
          alt="Smile Magazine Logo"
      />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--120 pb--190 bg_image bg-image-contact"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="rn-page-title text-center pt--100">
              <h2 class="heading-title theme-gradient">Contacta con nosotros</h2>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start Contact Address Area  -->
    <div class="rn-contact-address-area rn-section-gap bg_color--5">
      <v-container>
        <ContactAddress />
      </v-container>
    </div>
    <!-- End Contact Address Area  -->

    <!-- Start Contact Area  -->
    <div class="rn-contact-area rn-section-gap bg_color--1">
      <div class="contact-form--1">
        <v-container>
          <Contact>
            <img
              slot="contact-img"
              src="../../assets/images/about/about-6.jpg"
              alt="trydo"
            />
          </Contact>
        </v-container>
      </div>
    </div>
    <!-- End Contact Area  -->
    <Footer />
  </div>
</template>

<style>
.bg-image-contact {
  background-image: url('../../assets/images/contact/contacto-8.jpeg');
}
</style>

<script>
  import Header from "../layout/header/HeaderOnePage.vue";
  import ContactAddress from "../contact/sections/ContactAddress.vue";
  import Contact from "../contact/sections/Contact.vue";
  import Footer from "../layout/footer/Footer.vue";
  export default {
    components: { Header, ContactAddress, Contact, Footer },
    data() {
      return {};
    },
  };
</script>

<style></style>
